import { render } from "./vdog-podr-lookup.vue?vue&type=template&id=a45845ca"
import script from "./vdog-podr-lookup.vue?vue&type=script&setup=true&lang=js"
export * from "./vdog-podr-lookup.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/nsi/vid-dog-pril/vdog-podr-lookup.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a45845ca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a45845ca', __exports__)) {
    api.reload('a45845ca', __exports__)
  }
  
  module.hot.accept("./vdog-podr-lookup.vue?vue&type=template&id=a45845ca", () => {
    api.rerender('a45845ca', render)
  })

}


export default __exports__